import videojs from 'video.js';

import './fullscreen.css';

class FullScreenPlugin extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);
        // We want to allow users to hide the ios search bar and tabs since ios doesn't support the fullscreen api.
        // To do this we add a hidden element behind the video, that allows the user to scroll the page and hide the search bar and tabs.
        // We don't want this to show up when embedded in an iframe, since we have other fullscreen workarounds for that.
        if (videojs.browser.IS_IOS && window.self == window.top) {
            const iosFullscreenHelperElement = document.createElement('div');
            iosFullscreenHelperElement.classList.add('ios-fullscreen-helper');
            document.body.appendChild(iosFullscreenHelperElement);
        }
    }
}

export default FullScreenPlugin;